import React from "react";
import { Box } from "digiwash-components";
import { color as colorUtil, radii } from "@sloth-system/styled-utils";
import styled from "styled-components/native";

interface styledType {
  isSelected: boolean;
}
interface PropsType {
  width: number;
  height: number;
  selected: boolean;
}

const Container = styled(Box)`
  border: 2px solid
    ${(props: styledType) =>
      props.isSelected ? colorUtil("primary.main") : colorUtil("neutrals.850")};
  border-radius: ${radii("xs")};
`;

function Checkbox(props: PropsType) {
  return (
    <Container isSelected={props.selected}>
      <Box p="xs" style={{ width: props.width, height: props.height }}>
        <Box
          br="xs"
          bg={props.selected ? "primary.main" : "common.white"}
          style={{ width: "100%", height: "100%" }}
        />
      </Box>
    </Container>
  );
}

export default Checkbox;
